import { Pipe, PipeTransform } from '@angular/core';
import { PlanStepEnum } from '../../core';


/**
 * Pipe to calculate plan status.
 */
@Pipe({
	name: 'planStatus'
})
export class PlanStatusPipe implements PipeTransform {

	transform(planStep?: PlanStepEnum, isRevoked: boolean = false): PlanStatusEnum | null {
		if (isRevoked) return PlanStatusEnum.Revoked;
		switch (planStep) {
			case PlanStepEnum.Adjust:
				return PlanStatusEnum.AdjustedReport;
			case PlanStepEnum.Deformity:
			case PlanStepEnum.EOC:
			case PlanStepEnum.Mounting:
			case PlanStepEnum.Schedule:
			case PlanStepEnum.Report:
				return PlanStatusEnum.Active;
			default:
				return null;
		}
	}

}

export enum PlanStatusEnum {
	Active = 'Active',
	AdjustedReport = 'AdjustedReport',
	Revoked = 'Revoked'
}

export enum PlanStatusClassEnum {
	Active = "active",
	AdjustedReport = "adjusted-report",
	Revoked = "revoked"
}
